import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import QrCode from 'qrcode';
let default_1 = class default_1 extends Vue {
    txt;
    img = '';
    onTxt(nv) {
        this.toDataURL();
    }
    toDataURL() {
        if (!this.txt)
            return;
        console.log('toDataURL txt', this.txt);
        QrCode.toDataURL(this.txt, {
            margin: 0,
        }, (err, url) => {
            if (err)
                throw err;
            this.img = url;
        });
    }
    download() {
        if (!this.img)
            return;
        this.downloadBase64File(this.img, `${new Date().getTime()}`);
    }
    base64ToBlob(base64, mimeType) {
        const byteString = atob(base64.split(',')[1]); // 解码 base64 数据
        const arrayBuffer = new ArrayBuffer(byteString.length); // 创建缓冲区
        const uint8Array = new Uint8Array(arrayBuffer); // 创建字节数组
        // 将每个字符的字节填充到 Uint8Array
        for (let i = 0; i < byteString.length; i++) {
            uint8Array[i] = byteString.charCodeAt(i);
        }
        // 返回 Blob 对象
        return new Blob([uint8Array], { type: mimeType });
    }
    downloadBase64File(base64, fileName) {
        const mimeType = base64.match(/data:(.*?);base64/)?.[1]; // 提取 MIME 类型
        if (!mimeType)
            return;
        const blob = this.base64ToBlob(base64, mimeType); // 将 Base64 转换为 Blob
        const url = URL.createObjectURL(blob); // 创建一个临时 URL
        // 创建一个隐藏的 <a> 元素并触发点击事件下载文件
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // 释放 URL 对象
        URL.revokeObjectURL(url);
    }
};
__decorate([
    Prop()
], default_1.prototype, "txt", void 0);
__decorate([
    Watch('txt', { immediate: true })
], default_1.prototype, "onTxt", null);
default_1 = __decorate([
    Component
], default_1);
export default default_1;
